export enum FileType {
    Unknown,
    Email,
    PDf,
}
